import './unauthorized.css'

export default function Err404Page() {

    return (
        <div className="unauthorized_text">
            <h1>Error 404 - Page not found.... 😭</h1>
            <p>This page does not exist! Want to make this page a reality? Make a suggestion on our discord!</p>

            <a href="/">Return to the home page</a>
        </div>
    )   
}